import React, { useState, useEffect, useRef } from 'react';

const ResourcesSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [titleVisible, setTitleVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      setTitleVisible(true);
    }
  }, [isVisible]);

  return (
    <section
      ref={sectionRef}
      className={`bg-white section-spacing transition-all duration-1000 ease-in-out ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="container mx-auto px-4 md:px-8">
        <div className="mb-12">
          <h2
            className={`text-2xl md:text-4xl font-extralight text-center text-black mb-6 mt-10 transition-all duration-1000 ${
              titleVisible ? 'opacity-100 translate-y-0 animate-slideUp' : 'opacity-0 translate-y-10'
            }`}
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Elixir's Wellness Power
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-10 mt-12 mx-6">
          {/* Box 1 */}
          <div className="w-full md:w-1/2 bg-[rgba(248,248,248,0.5)] rounded-lg p-8 text-center shadow-sm">
            <div className="bg-[#D4AF37] rounded-full w-16 h-16 flex items-center justify-center text-2xl mx-auto mb-4">
              🌿
            </div>
            <p className="text-lg text-[#333]">
              <span style={{ fontFamily: "'Playfair Display', serif" }}>Honey as Medicine, Honey as Pleasure</span><br />
              For centuries, honey has been revered for its therapeutic properties. Elixir takes this
              tradition to a new level, offering a luxurious 'alicament' – a food that nourishes both body
              and soul. Discover the power of nature's remedy.
            </p>
          </div>

          {/* Box 2 */}
          <div className="w-full md:w-1/2 bg-[rgba(248,248,248,0.5)] rounded-lg p-8 text-center shadow-sm">
            <div className="bg-[#D4AF37] rounded-full w-16 h-16 flex items-center justify-center text-2xl mx-auto mb-4">
              💚
            </div>
            <p className="text-lg text-[#333]">
              <span style={{ fontFamily: "'Playfair Display', serif" }}>The Gift of Well-being, in Every Drop</span><br />
              Elixir is rich in antioxidants, possesses antibacterial properties, and offers a range of other
              health benefits. Explore how Elixir can enhance your well-being.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResourcesSection;
